export const BACKGROUND_COLOR = {
  default: 'linear-gradient(270deg, #006cfd 0.02%, #ffe1ff 100%)',
  bar: '#0468ff'
};
export const PROGRESS_COLOR = '#e6f0ff';